// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.css
// module id = 2197
// module chunks = 33